/** Ce qu'il faut savoir pour amorcer un flux d'autorisation. */
export interface AuthorizationRequest {
  /**
   * L'origine du serveur d'autorisation, sans barre finale — par exemple
   * `https://login.renovationman.com`. Chaîne vide pour la **même origine**, ce qui est le cas du
   * portail, qui est servi par ce serveur-là (story O2.3).
   */
  issuer: string;
  clientId: string;
  /** Doit correspondre **exactement** à l'URI enregistrée côté serveur : la validation n'a pas de joker. */
  redirectUri: string;
  scope: string;
}

/** La réponse de `/oauth2/token`, telle que le serveur la nomme. */
export interface OAuthTokens {
  access_token: string;
  token_type: string;
  expires_in: number;
  id_token?: string;
  refresh_token?: string;
  scope?: string;
}

export interface OAuthCallbackResult {
  tokens: OAuthTokens;
  /** Le lien profond rangé à l'amorçage, ou `null` — l'appelant va alors à son accueil. */
  deepLink: string | null;
}

/** Ce que rejette `consume()`. Le `reason` est fait pour être journalisé, pas montré à l'utilisateur. */
export class OAuthCallbackError extends Error {
  constructor(readonly reason: string, message?: string) {
    super(message ?? reason);
    this.name = 'OAuthCallbackError';
  }
}
